<ng-container *ngIf="itemSelectorIncludesPackages; else tabbedSelector" [ngTemplateOutlet]="itemSelector" />
<ng-template #tabbedSelector>
  <mat-tab-group>
    <mat-tab *ngIf="!hideSellingStandaloneProducts" [label]="'FRONTEND.SALES_UI.PRODUCTS' | translate">
      <ng-container [ngTemplateOutlet]="itemSelector" />
    </mat-tab>
    <mat-tab *ngIf="!hidePackages" [label]="'FRONTEND.SALES_UI.PACKAGES' | translate">
      <div class="old-package-selector-styling">
        <sales-ui-sales-order-package-selector
          #packages
          [preselectedPackages]="preselectedPackages"
          [marketId]="marketId"
        />
      </div>
    </mat-tab>
  </mat-tab-group>
</ng-template>

<ng-template #itemSelector>
  <sales-ui-sales-order-item-selector-adapter
    #itemSelectorAdapter
    [selectedApps]="preselectedApps"
    [selectedPackages]="preselectedPackages"
    [config]="{
      partnerId: partnerId,
      marketId: marketId,
      pageSize: 15,
      hideOwnerName: hideOwnerName,
      hideWholesale: !wholesalePricing,
      hideRetail: wholesalePricing,
      hideQuantity: true,
      hideItemsWithOrderForms: hideOrderFormProducts,
      itemTypesAvailable: itemTypesAvailable,
    }"
  />
</ng-template>
